<template>
  <v-row>
    <v-col cols="12">
      <v-alert type="error" v-if="splitEndDateError || endDateError">
        The end date is not the same as the start date
      </v-alert>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Valet Purpose"
                    v-model="booking.purpose" color="primary"/>
      <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" v-model="isSingleService"
                  label="UNTICK FOR MULTIPLE ELEMENT BOOKINGS"/>
      <div v-if="isSingleService">
        <v-autocomplete :disabled="booking.parentBookingId || booking.isApproved" @change="updatePriceWithChange"
                        v-model="booking.valet" label="Select Valet" :items="services" item-value="code"
                        item-text="name"/>
        <v-select ref="carSelect1" @change="$refs.carSelect1.isMenuActive = false"  chips multiple deletable-chips :items="booking.customer.vehicles" label="Select Vehicle/s" placeholder="Assign a vehicle/s to the service" item-text="registration" return-object v-model="booking.vehicles">
          <template v-slot:item="{item}">
            {{item.registration}} - {{item.make}} - {{item.model}} - {{item.colour}}
          </template>
        </v-select>
        <v-autocomplete :disabled="booking.parentBookingId || booking.isApproved" @change="updateDescriptionWithScript"
                        v-model="script" label="Use Script (Optional)" hint="This will automatically populate the description for you" persistent-hint :items="scripts" item-value="details"
                        item-text="name"/>
        <v-textarea v-model="booking.description" label="Service Description"/>
        <v-select :disabled="booking.parentBookingId || booking.isApproved" clearable
                  v-model="booking.xeroValetTrackingId" label="Select Technician for Commission Tracking"
                  item-text="name" item-value="name" :items="technicians"/>
        <v-select @change="updateAccountCode" :disabled="booking.isApproved" clearable v-if="renderComponent"
                  v-model="booking.xeroAccountName" label="Select Account Code" item-text="name" item-value="name"
                  :items="accounts"/>
        <v-text-field :disabled="booking.parentBookingId || booking.isApproved"
                      v-if="showReasonField"
                      v-model="booking.xeroAccountCodeReason" ref="account-reason" label="Enter reason for Sales code"/>
      </div>

      <div v-if="!isSingleService">
        <div>
          <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" v-model="booking.isSplitPerBooking"
                      label="Multiple line item booking - first line item Zero" />
          <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" v-model="booking.isCosmeticBooking"
                      label="Cosmetic repair with subcontracted COST element - First line item is Zero" />
          <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" v-model="isGiftVoucher" label="Gift voucher - First line item MUST be NET price of booking"></v-checkbox>
          <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" v-model="isMultiCredit" label="Multiple credit bookings and package deals - First line item MUST be NET price of booking"></v-checkbox>
          <v-sheet color="grey lighten-3" class="pa-2">
            <p class="headline">Parent Description</p>
            <v-autocomplete :disabled="booking.parentBookingId || booking.isApproved" @change="updateDescriptionWithScript"
                            v-model="parentScript" label="Use Script (Optional)" hint="This will automatically populate the description for you" persistent-hint :items="scripts" item-value="details"
                            item-text="name"/>
            <v-textarea v-model="booking.description" label="Service Description"/>
          </v-sheet>
          <v-autocomplete :disabled="booking.parentBookingId || booking.isApproved" @change="updateUnitPrice"
                          v-model="valet" label="Select Valet" :items="services" item-value="code" item-text="name"/>
          <v-select ref="carSelect" @change="$refs.carSelect.isMenuActive = false" chips multiple deletable-chips :items="booking.customer.vehicles" label="Select Vehicle/s" placeholder="Assign a vehicle/s to the service" item-text="registration" return-object v-model="vehicle">
            <template v-slot:item="{item}">
              {{item.registration}} - {{item.make}} - {{item.model}} - {{item.colour}}
            </template>
          </v-select>
          <v-autocomplete :disabled="booking.parentBookingId || booking.isApproved" @change="updateDescriptionWithScript"
                          v-model="script" label="Use Script (Optional)" hint="This will automatically populate the description for you" persistent-hint :items="scripts" item-value="details"
                          item-text="name"/>
          <v-textarea v-model="description" label="Service Description"/>
          <v-autocomplete @change="updateTechName" :disabled="booking.parentBookingId || booking.isApproved" clearable
                          v-model="xeroValetTrackingId" label="Select Technician for Commission Tracking"
                          item-text="name" item-value="name" :items="technicians"/>
          <v-autocomplete @change="updateAccountCodeSplit" :disabled="booking.parentBookingId || booking.isApproved"
                          clearable v-if="renderComponent" v-model="xeroAccountName" label="Select Account Code"
                          item-text="name" item-value="name" :items="accounts"/>
          <v-text-field :disabled="booking.parentBookingId || booking.isApproved" prefix="£" label="Unit Price"
                        v-model.number="unitPrice" color="primary"/>
          <v-btn :disabled="booking.parentBookingId || booking.isApproved" color="primary" @click="addService">Add
            Service
          </v-btn>

          <v-data-table :headers="serviceHeaders" :items="selectedServices" class="elevation-1 mt-5">
            <template v-slot:item.actions="{item}">
              <v-icon v-if="item.bookingId" color="info" class="mr-2" @click="loadChild(item)">mdi-human-child</v-icon>
              <v-icon :disabled="booking.parentBookingId || booking.isApproved" color="error" class="mr-2"
                      @click="deleteService(item)">mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>

      </div>
      <v-select v-if="booking.parentBookingId && renderComponent" @change="updateAccountCode"
                :disabled="booking.isApproved" clearable v-model="booking.xeroAccountName" label="Select Account Code"
                item-text="name" item-value="name" :items="accounts"/>
      <v-select :disabled="booking.parentBookingId || booking.isApproved" clearable
                v-model="booking.xeroCommissionTrackingId" label="Select Commission Basis" item-text="name"
                item-value="name" :items="periods"/>
      <v-text-field style="display: none" disabled v-model="booking.xeroAccountCode" color="primary"/>
    </v-col>
    <v-col cols="12" sm="6">
      <v-text-field :disabled="booking.parentBookingId || booking.isApproved" prefix="£" label="Net Price"
                    v-model.number="booking.price" color="primary" @blur="updatePrice"/>
      <v-datetime-picker :disabled="booking.isApproved" label="Start Date/Time" v-model="localStartDate"
                         :timePickerProps="{format: '24hr'}">
        <template v-slot:dateIcon>
          <v-icon>mdi-calendar</v-icon>
        </template>
        <template v-slot:timeIcon>
          <v-icon>mdi-clock-outline</v-icon>
        </template>
      </v-datetime-picker>
      <v-datetime-picker :disabled="booking.isApproved" v-if="localStartDate" label="End Date/Time"
                         v-model="localEndDate"
                         :datePickerProps="{min: localStartDate}"
                         :timePickerProps="{format: '24hr'}">
        <template v-slot:dateIcon>
          <v-icon>mdi-calendar</v-icon>
        </template>
        <template v-slot:timeIcon>
          <v-icon>mdi-clock-outline</v-icon>
        </template>
      </v-datetime-picker>
      <p>Can this booking be changed?</p>
      <v-layout>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Yes"
                    v-model="booking.canBeChanged" value="yes" />
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="No"
                    v-model="booking.canBeChanged" value="no" class="ml-3" />
        <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Other" v-model="booking.canBeChanged" class="ml-3" />
      </v-layout>
      <p>Is Power Available?</p>
      <v-layout>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Yes"
                    v-model="booking.hasPower" value="yes" />
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="No"
                    v-model="booking.hasPower" value="no" class="ml-3" />
        <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Other" v-model="booking.hasPower" class="ml-3" />
      </v-layout>

      <p>Is Water Available?</p>
      <v-layout>
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="Yes"
                    v-model="booking.hasWater" value="yes" />
        <v-checkbox :disabled="booking.parentBookingId || booking.isApproved" label="No"
                    v-model="booking.hasWater" value="no" class="ml-3" />
        <v-text-field :disabled="booking.parentBookingId || booking.isApproved" label="Other" v-model="booking.hasWater" class="ml-3" />
      </v-layout>

    </v-col>
  </v-row>
</template>

<script>
import {mapActions, mapState} from 'vuex';
import {PeriodsHttp} from "../../../http/PeriodsHttp";
import EventBus from "../../../EventBus";
import {BookingsHttp} from "@/http/BookingsHttp";

export default {
  name: "ValetDetails",
  props: {
    booking: Object
  },
  mounted() {
    this.vehicle = null;
    EventBus.$on('reset-valet-details', () => {
      this.selectedServices = [];
      this.isSingleService = true;
      this.vehicle = null;
    })
  },
  data() {
    return {
      vehicle: [],
      script: null,
      parentScript: null,
      renderComponent: true,
      localStartDate: null,
      localEndDate: null,
      localSplitStartDate: null,
      localSplitEndDate: null,
      endDateError: false,
      splitEndDateError: false,
      isSingleService: true,
      valet: '',
      xeroValetTrackingId: '',
      xeroAccountName: '',
      unitPrice: 0,
      selectedServices: [],
      serviceHeaders: [
        {text: 'Valet', value: 'valet'},
        {text: 'Tracking ID', value: 'xeroValetTrackingId'},
        {text: 'Account Name', value: 'xeroAccountName'},
        {text: 'Price', value: 'unitPrice'},
        {text: 'Actions', value: 'actions', sortable: false}
      ],
      description: '',
      isInvoiceApproved: false,
      isGiftVoucher: false,
      isMultiCredit: false,
      showReasonField: false
    }
  },
  computed: {
    ...mapState("xero", ["services", "periods", "technicians", "accounts"]),
    ...mapState("technicians", ["appTechnicians"]),
    ...mapState("scripts", ["scripts"])
  },
  watch: {
    localStartDate(newVal) {
      this.booking.startDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.booking.startDate);
        const momentEnd = this.$moment(this.booking.endDate);
        this.endDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    localEndDate(newVal) {
      this.booking.endDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.booking.startDate);
        const momentEnd = this.$moment(this.booking.endDate);
        this.endDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    localSplitStartDate(newVal) {
      this.booking.startSplitDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.booking.startSplitDate);
        const momentEnd = this.$moment(this.booking.endSplitDate);
        this.splitEndDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    localSplitEndDate(newVal) {
      this.booking.endSplitDate = new Date(newVal);
      if (newVal) {
        const momentStart = this.$moment(this.booking.startSplitDate);
        const momentEnd = this.$moment(this.booking.endSplitDate);
        this.splitEndDateError = !momentEnd.isSame(momentStart, 'day');
      }
    },
    "booking.startDate"(newVal) {
      if (newVal) {
        this.fetchPeriod(newVal);
      }
    },
    "booking.selectedServices": {
      handler(newVal) {
        // eslint-disable-next-line no-console
        //console.log(newVal);
        if (newVal && newVal.length > 0 && this.booking._id) {
          this.selectedServices = newVal;
          this.isSingleService = false;
          this.forceRerender();
        }
      },
      deep: true,
      immediate: true
    },
    "isGiftVoucher": {
      handler(newVal) {
        if (newVal) {
          this.selectedServices = [];
        }
        this.booking.isGiftVoucher = newVal;
      },
      deep: true,
      immediate: true
    },
    "isMultiCredit": {
      handler(newVal) {
        if (newVal) {
          this.selectedServices = [];
        }
        this.booking.isMultiCredit = newVal;
      },
      deep: true,
      immediate: true
    },
    "booking.isSplitPerBooking": {
      handler(newVal) {
        if (newVal) {
          if (this.selectedServices.length === 0) {
            if (!this.booking.isGiftVoucher && !this.booking.isMultiCredit) {
              this.selectedServices.push({
                valet: "OS",
                xeroValetTrackingId: "Office",
                xeroAccountName: "Sales",
                unitPrice: 0
              });
            }

            this.xeroValetTrackingId = "Office";
            this.xeroAccountName = "Sales";
            this.valet = "OS";
          }
        }
      },
      deep: true,
      immediate: true
    },"booking.isCosmeticBooking": {
      handler(newVal) {
        if (newVal) {
          if (this.selectedServices.length === 0) {
            if (!this.booking.isGiftVoucher && !this.booking.isMultiCredit) {
              this.selectedServices.push({
                valet: "OS",
                xeroValetTrackingId: "Office",
                xeroAccountName: "Sales",
                unitPrice: 0
              });
            }

            this.xeroValetTrackingId = "Office";
            this.xeroAccountName = "Sales";
            this.valet = "OS";
          }
        }
      },
      deep: true,
      immediate: true
    },
    booking: {
      handler(newVal) {
        if (newVal.startDate) {
          const tempDate = this.$moment(newVal.startDate);
          if (tempDate) {
            this.localStartDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }
        if (newVal.endDate) {
          const tempDate = this.$moment(newVal.endDate);
          if (tempDate) {
            this.localEndDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }
        if (newVal.startSplitDate) {
          const tempDate = this.$moment(newVal.startSplitDate);
          if (tempDate) {
            this.localSplitStartDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }
        if (newVal.endSplitDate) {
          const tempDate = this.$moment(newVal.endSplitDate);
          if (tempDate) {
            this.localSplitEndDate = tempDate.format('YYYY-MM-DD HH:mm');
          }
        }

        if (!newVal.endDate) {
          newVal.endDate = newVal.startDate;
        }
        if (!newVal.xeroAccountName) {
          newVal.xeroAccountName = "Sales (30%)";
        }
        if (newVal.xeroValetTrackingId && newVal.xeroValetTrackingId.length > 0) {
          if (this.appTechnicians && this.appTechnicians.length > 0) {
            if (this.appTechnicians.find(x => x.name === newVal.xeroValetTrackingId)) {
              newVal.valetId = this.appTechnicians.find(x => x.name === newVal.xeroValetTrackingId)._id;
            }
          }
        }
        if (newVal.xeroAccountName && newVal.xeroAccountName.length > 0) {
          if (this.accounts.find(x => x.name === newVal.xeroAccountName)) {
            this.booking.xeroAccountCode = this.accounts.find(x => x.name === newVal.xeroAccountName).code;
            this.updatePrice();
          }
        }

        if (newVal._id && newVal.selectedServices && newVal.selectedServices.length > 0) {
          this.isInvoiceApproved = true;
        }

        this.showReasonField = newVal.xeroAccountName && newVal.xeroAccountName !== 'Sales (30%)';

        this.isMultiCredit = newVal.isMultiCredit;
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("bookings", ["setManageBookingDialog", "setActiveBooking", "setBookings"]),
    updateUnitPrice() {
      this.unitPrice = this.services.find(x => x.code === this.valet).salesDetails.unitPrice;
      this.description = this.services.find(x => x.code === this.valet).description;
      const durationEndChar = this.description.indexOf("Duration:");
      const char1 = this.description.charAt(durationEndChar + 10);
      const char2 = this.description.charAt(durationEndChar + 11);
      const char3 = this.description.charAt(durationEndChar + 12);
      let duration = Number(char1 + char2);
      if (char3 !== "") {
        duration = Number(char1 + char2 + char3);
      }
      if (duration >= 60) {
        const hours = Math.floor(duration / 60);
        const minutes = duration % 60;
        this.description = this.description.replace(`Duration: ${duration.toString()}`, `Duration: ${hours} Hours ${minutes} Minutes`);
      } else {
        this.description = this.description.replace(`Duration: ${duration.toString()}`, `Duration: ${duration} Minutes`);
      }
    },
    updatePrice() {
      EventBus.$emit('price-change', this.booking.price);
    },
    updateAccountCode() {
      this.showReasonField = this.booking.xeroAccountName && this.booking.xeroAccountName !== 'Sales (30%)';
    },
    updateTechName() {
      if (this.xeroValetTrackingId !== 'Office' && this.xeroValetTrackingId !== 'COST' && this.xeroValetTrackingId !== 'Daniel' && this.xeroValetTrackingId !== 'Reschedule') {
        if (this.xeroAccountName !== 'Sales (30%)' && this.xeroAccountName !== 'Sales (35%)' && this.xeroAccountName !== 'Sales (40%)' && this.xeroAccountName !== 'Sales (50%)' && this.xeroAccountName !== 'Sales (60%)' && this.xeroAccountName !== 'Sales (100%)') {
          setTimeout(() => {
            this.xeroAccountName = null;
          }, 100);
        }
      } else if (this.xeroValetTrackingId === 'Office' || this.xeroValetTrackingId === 'COST' || this.xeroValetTrackingId === 'Daniel' || this.xeroValetTrackingId === 'Reschedule') {
        if (this.xeroAccountName === 'Sales (30%)' || this.xeroAccountName === 'Sales (35%)' || this.xeroAccountName === 'Sales (40%)' || this.xeroAccountName === 'Sales (50%)' || this.xeroAccountName === 'Sales (60%)' || this.xeroAccountName === 'Sales (100%)') {
          setTimeout(() => {
            this.xeroAccountName = null;
          }, 100);
        }
      }
    },
    updateAccountCodeSplit() {
      if (this.xeroValetTrackingId !== 'Office' && this.xeroValetTrackingId !== 'COST' && this.xeroValetTrackingId !== 'Daniel' && this.xeroValetTrackingId !== 'Reschedule') {
        if (this.xeroAccountName !== 'Sales (30%)' && this.xeroAccountName !== 'Sales (35%)' && this.xeroAccountName !== 'Sales (40%)' && this.xeroAccountName !== 'Sales (50%)' && this.xeroAccountName !== 'Sales (60%)' && this.xeroAccountName !== 'Sales (100%)') {
          setTimeout(() => {
            this.xeroAccountName = null;
          }, 100);
        }
      } else if (this.xeroValetTrackingId === 'Office' || this.xeroValetTrackingId === 'COST' || this.xeroValetTrackingId === 'Daniel' || this.xeroValetTrackingId === 'Reschedule') {
        if (this.xeroAccountName === 'Sales (30%)' || this.xeroAccountName === 'Sales (35%)' || this.xeroAccountName === 'Sales (40%)' || this.xeroAccountName === 'Sales (50%)' || this.xeroAccountName === 'Sales (60%)' || this.xeroAccountName === 'Sales (100%)') {
          setTimeout(() => {
            this.xeroAccountName = null;
          }, 100);
        }
      }
    },
    updateDescriptionWithScript() {
      // Find the description first
      if (this.booking.isSplitPerBooking || this.booking.isCosmeticBooking) {
        if (this.parentScript) {
          this.booking.description = `Description: \n${this.parentScript}`;
          this.parentScript = null;
        } else if (this.script) {
          // this.description = `${this.services.find(x => x.code === this.valet).description}\n Description: \n${this.script}`;
          const descriptionStartChar = this.description.indexOf("Description:");
          this.description = this.description.substring(0, descriptionStartChar) + `Description: \n${this.script}`;
          this.script = null;
        }
      } else {
        const descriptionStartChar = this.booking.description.indexOf("Description:");
        this.booking.description = this.booking.description.substring(0, descriptionStartChar) + `Description: \n${this.script}`;
        this.script = null;
      }

    },
    updatePriceWithChange() {
      if (this.services.find(x => x.code === this.booking.valet)) {
        this.booking.price = parseFloat(this.services.find(x => x.code === this.booking.valet).salesDetails.unitPrice.toFixed(2));
        this.booking.description = this.services.find(x => x.code === this.booking.valet).description;
        // We do automation here
        // Find the duration first
        const durationEndChar = this.booking.description.indexOf("Duration:");
        const char1 = this.booking.description.charAt(durationEndChar + 10);
        const char2 = this.booking.description.charAt(durationEndChar + 11);
        const char3 = this.booking.description.charAt(durationEndChar + 12);

        let duration = Number(char1 + char2);
        if (char3 !== "") {
          duration = Number(char1 + char2 + char3);
        }
        this.booking.duration = duration;
        this.booking.endDate = this.$moment(this.booking.startDate).add(this.booking.duration, 'minutes');
        // Now update the description to Hours
        if (duration >= 60) {
          const hours = Math.floor(duration / 60);
          const minutes = duration % 60;
          this.booking.description = this.booking.description.replace(`Duration: ${duration.toString()}`, `Duration: ${hours} Hours ${minutes} Minutes`);
        } else {
          this.booking.description = this.booking.description.replace(`Duration: ${duration.toString()}`, `Duration: ${duration} Minutes`);
        }
      }
      EventBus.$emit('price-change', this.booking.price);
    },
    async fetchPeriod(date) {
      this.booking.xeroCommissionTrackingId = date ? await PeriodsHttp.getPeriodByDate(new Date(date)).then(result => result.data.name) : this.booking.xeroCommissionTrackingId = await PeriodsHttp.getPeriodByDate(new Date()).then(result => result.data.name);
      this.forceRerender();
    },
    forceRerender() {
      // Remove my-component from the DOM
      this.renderComponent = false;

      this.$nextTick(() => {
        // Add the component back in
        this.renderComponent = true;
      });
    },
    addService() {
      this.selectedServices.push({
        valet: this.valet,
        xeroValetTrackingId: this.xeroValetTrackingId,
        xeroAccountName: this.xeroAccountName,
        unitPrice: this.unitPrice,
        vehicles: this.vehicle,
        description: this.description
      });
      this.valet = '';
      this.xeroValetTrackingId = '';
      this.xeroAccountName = 'Sales (30%)';
      this.description = '';
      this.unitPrice = 0;
      this.booking.price = 0;
      this.selectedServices.forEach(n => {
        this.booking.price = Number(this.booking.price) + n.unitPrice;
      });
      this.booking.selectedServices = this.selectedServices;
      this.vehicle = [];
      EventBus.$emit('price-change', this.booking.price);
      this.forceRerender();
    },
    async deleteService(item) {
      const index = this.selectedServices.findIndex(x => x.valet === item.valet && x.xeroValetTrackingId === item.xeroValetTrackingId);
      const bookingItem = this.selectedServices[index];
      if (bookingItem.bookingId) {
        await BookingsHttp.deleteBooking(bookingItem.bookingId);
      }
      this.selectedServices.splice(index, 1);
      this.booking.price = parseInt(this.booking.price) - item.unitPrice;
      EventBus.$emit('price-change', this.booking.price);
      this.booking.selectedServices = this.selectedServices;
      this.forceRerender();
    },
    async loadChild(item) {
      await this.setManageBookingDialog(false);
      EventBus.$emit('set-scheduler-date', item.startDate);
      await this.setActiveBooking(await BookingsHttp.getSingleBooking(item.bookingId).then(result => result.data));
      await this.setManageBookingDialog(true);
    }
  }
}
</script>
